function CollapseView({ raw, onEdit, onDelete }) {
  return (
    <div className="border p-3 rounded bg-white">
      <div className="mb-3">
        <p className="mb-1">
          <strong>SKU:</strong> {raw?.sku}
        </p>
        <p className="mb-1">
          <strong>Item Name:</strong> {raw?.itemName}
        </p>
        <p className="mb-1">
          <strong>UOM:</strong> {raw?.uom?.name}
        </p>
        <p className="mb-1">
          <strong>Pieces / Quantity:</strong> {raw?.quantity}
        </p>
        <p className="mb-1">
          <strong>Cost:</strong> {raw?.cost}
        </p>
      </div>

      <div className="d-flex gap-2">
        <button className="btn btn-success text-white" onClick={onEdit}>
          <i className="bi bi-pencil-fill me-2"></i> Edit
        </button>
        <button className="btn btn-danger" onClick={onDelete}>
          <i className="bi bi-trash-fill me-2"></i> Delete
        </button>
      </div>
    </div>
  );
}

export default CollapseView;
